import {request} from '@/sealFilter/request'

//保存新增链接
export function saveAddLivelink(data) {
    return request({
        url: '/tLiveBooks/save',
        method: 'post',
        data
    })
}

//修改链接
export function updateLivelink(data) {
    return request({
        url: '/tLiveBooks/update',
        method: 'post',
        data
    })
}

//获取直播带货链接
export function getLivelink(data) {
    return request({
        url: '/tLiveBooks/getlink',
        method: 'GET',
        params: data
    })
}

//删除直播带货链接
export function deleteLivelink(data) {
    return request({
        url: '/tLiveBooks/del',
        method: 'GET',
        params: data
    })
}




// WEBPACK FOOTER //
// ./src/api/liveLink.js